import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  subscription: null,
  features: [],
  createSuccess: false,
  hasSubscription: false,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    // Create Subscription
    createSubscriptionStart: (state) => {
      state.loading = true;
      state.error = null;
      state.createSuccess = false;
    },
    createSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.subscription = action.payload;
      state.createSuccess = true;
      state.hasSubscription = true;
      state.error = null;
    },
    createSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.createSuccess = false;
    },

    // Get User Subscription
    getUserSubscriptionStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getUserSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.subscription = action.payload.subscription;
      state.features = action.payload.features || [];
      state.hasSubscription = true;
      state.error = null;
      console.log("✅ Redux State Updated - Subscription:", state.subscription);
      console.log("✅ Plan name in Redux:", state.subscription?.plan_name);
    },
    getUserSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.hasSubscription = false;
      state.subscription = null;
      state.features = [];
    },

    // Clear State
    clearSubscriptionError: (state) => {
      state.error = null;
    },
    clearCreateSuccess: (state) => {
      state.createSuccess = false;
    },
  },
});

export const {
  createSubscriptionStart,
  createSubscriptionSuccess,
  createSubscriptionFailure,
  getUserSubscriptionStart,
  getUserSubscriptionSuccess,
  getUserSubscriptionFailure,
  clearSubscriptionError,
  clearCreateSuccess,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
